import * as moment from 'moment';
import { Location } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Challenge, ChallengeService } from 'app/shared/services/challenge.service';
import { Subject } from 'rxjs';

/**
 * Modal component to select team out of available teams or found an own team and invite members.
 */
@Component({
  selector: 'app-challenge-tutorial',
  templateUrl: './challenge-tutorial.component.html',
  styleUrls: ['./challenge-tutorial.component.scss'],
})
export class ChallengeTutorialComponent implements OnInit, OnDestroy {
  // The currently active challenge
  public challenge: Challenge;

  // How many days the challenge runs
  public challengeDurationInWeeks: number;

  private ngUnsubscribe: Subject<void> = new Subject<void>();

  constructor(private challengeService: ChallengeService, private location: Location) {}

  public ngOnInit(): void {
    this.challengeService.displayedChallenge.takeUntil(this.ngUnsubscribe).subscribe((challenge) => {
      if (challenge) {
        this.challenge = challenge;

        // 7 days count as a week, only full weeks are counted
        this.challengeDurationInWeeks = Math.trunc((moment(challenge.end).diff(moment(challenge.start), 'days') + 1) / 7);
      }
      this.challenge = challenge;
    });
  }

  public closeModal(): void {
    this.location.back(); // <-- go back to previous location on cancel
  }

  /**
   * On destroy cancel active subscriptions
   */
  public ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/pages/challenge-tutorial/challenge-tutorial.component.ts